// extracted by mini-css-extract-plugin
export default {"FormGroup":"PreviewEmailModal_FormGroup__e2JrE"};